import Image from "next/image";
import {memo, useEffect, useMemo, useState} from "react";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { API, getAll } from "../../../../../services";
import { setTrailer } from "../../../../../redux/slices/videoDataSlice";
import { conditions, imageFormatChecking } from "../../../../../helpers";
import { ConditionName } from "../../../../../interfaces";
import { setTrailerPopover } from "../../../../../redux/slices/popoversSlice";
import IMAGES from "../../../../../images/importImages";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const TruncateMarkup = dynamic(() => import("react-truncate-markup"));
const CameraIcon = dynamic(() => import("../../icon-components/cameraIcon"));

const Trailer = () => {

    const dispatch = useAppDispatch();
    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    const { details, trailer } = useAppSelector(({ videoData: { details, trailer, params, videoElementSizeInfo } }) => ({ details, trailer, params, videoElementSizeInfo }), shallowEqual);
    const [showCompleteDescription, setShowCompleteDescription] = useState<boolean>(false);

    useEffect(() => {
        (async()=>{
            const data:any = await getAll(API().trailer.getList)
            dispatch(setTrailer(data))
        })()
    }, [])

    const imageNumber = useMemo(() => trailer.filter((item: any) => imageFormatChecking(item.file_name)).length, [trailer.length]);
    const videoNumber = useMemo(() => trailer.filter((item: any) => !imageFormatChecking(item.file_name)).length, [trailer.length]);

    return (
        <>
            {conditions(ConditionName.hasTrailer) && (
                <div
                    className={`pl-flex ${conditions(ConditionName.isComplexDesktop) ? "pl-flex-row pl-gap-[24px]" : "pl-flex-col pl-gap-[16px]"} pl-items-start pl-w-full`}>
                    <div
                        className={`pl-cursor-pointer pl-relative pl-flex pl-items-center pl-justify-center ${conditions(ConditionName.isComplexDesktop) ? "pl-w-1/2" : "pl-w-full"} pl-bg-black pl-py-4 pl-aspect-video`}>
                        <div className="pl-w-full pl-h-full">
                            {conditions(ConditionName.hasBanner) && <Image src={imageFormatChecking(trailer[0].file_name) ? trailer[0].url : trailer[0].banner ?? ""} layout={"fill"} alt="trailer-banner" />}
                        </div>
                        <div
                            className={`${conditions(ConditionName.isTouchScreenPortrait) ? "pl-bottom-4 pl-right-1" : "pl-bottom-[20px] pl-right-2"} pl-flex pl-items-center pl-rounded-[20px] pl-absolute pl-bg-gray-highLight pl-text-black dark:pl-text-white dark:pl-bg-black pl-text-[14px] pl-font-normal`}>
                            <div className="pl-w-8 pl-h-8 pl-rounded-full pl-bg-white pl-p-1"><CameraIcon /></div>
                            <div
                                className={`pl-py-[5px] ${conditions(ConditionName.isComplexPortrait) ? "pl-px-[8px]" : "pl-px-[12px]"}`}>{`${videoNumber !== 0 ? `${videoNumber} ویدیو ${imageNumber !== 0 ? "و " : ""}` : ''} ${imageNumber !== 0 ? `${imageNumber} عکس` : ""}`}</div>
                        </div>
                        <div className="pl-absolute">
                            <Image
                                onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(setTrailerPopover(true));
                                }}
                                src={IMAGES.bigPlay}
                                width={conditions(ConditionName.isMiniPlayer) ? 48 : conditions(ConditionName.isTouchScreen) ? 56 : 72}
                                height={conditions(ConditionName.isMiniPlayer) ? 48 : conditions(ConditionName.isTouchScreen) ? 56 : 72}
                                className={`${conditions(ConditionName.isPlay) ? "pl-big-play-icon" : "pl-big-pause-icon"}`}
                            />
                        </div>
                    </div>
                    <div
                        className={`pl-flex ${conditions(ConditionName.isComplexDesktop) ? "pl-w-1/2" : "pl-w-full"} pl-flex-col pl-gap-2`}>
                        <div className="pl-text-[14px] pl-font-normal pl-leading-[26px] pl-text-justify">
                            {
                                conditions(ConditionName.hasDescription) && (
                                    conditions(ConditionName.isComplexPortrait) ? (
                                        <div className="pl-border-b pl-border-secondary-500 pl-pb-4">
                                            {showCompleteDescription ? (
                                                <div
                                                    className="pl-max-w-screen pl-overflow-hidden pl-text-[14px] pl-font-normal dark:pl-text-dark-5 pl-bg-white pl-whitespace-pre-wrap dark:pl-bg-dark-1 pl-flex-1  no-scrollbar pl-text-justify">
                                                    {details.description}
                                                    <span onClick={() => setShowCompleteDescription(false)} className="pl-text-primary-600">{"کمتر..."}</span>
                                                </div>
                                            ) :
                                                (
                                                    <TruncateMarkup
                                                        ellipsis={() => <span onClick={() => setShowCompleteDescription(true)} className="pl-text-primary-600">{" بیشتر..."}</span>}
                                                        lines={2}
                                                    >
                                                        <div
                                                            className="pl-text-[14px] pl-font-normal dark:pl-text-dark-5 pl-bg-white dark:pl-bg-dark-1 pl-flex-1  no-scrollbar pl-text-justify">{details.description}</div>
                                                    </TruncateMarkup>
                                                )}
                                        </div>
                                    ) : (
                                        <div>{details.description}</div>
                                    )
                                )
                            }
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default memo(Trailer);
